<template>
  <div class="content-block" id="set-block">
    <div class="info-title">通用设置</div>
    <div class="content-layer">
      <div class="set-card" v-loading="processLoading">
        <div class="set-card-left">
          <div class="set-title-wrap">
            <span class="set-title">短信通知接收</span>
            <span class="set-tag enable" v-if="SMSstate">
              <svg-icon iconClass="icon-enable" style="width: 12px;height: 12px;"></svg-icon>
              <span>已启用</span>
            </span>
            <span class="set-tag disable" v-else>
              <svg-icon iconClass="icon-disable" style="width: 12px;height: 12px;"></svg-icon>
              <span>已关闭</span>
            </span>
          </div>
          <div class="set-sub">
            开启短信通知，及时收到合同签署提醒
          </div>
        </div>
        <div class="set-card-right">
          <el-switch v-model="SMSstate" @change="SMSchhange">
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { changeSmsRemindSwitch } from "@/api/account/account";
import { getUserAccountInfo } from "@/api/home"

export default {
  ...mapState(["userInfo", "userContractInfo", "companyList"]),
  components: {
  },
  data() {
    return {
      SMSstate: false,
      processLoading: false
    };
  },

  created() {
    this.getUserAccountInfo();
  },
  mounted() {
    this.SMSstate = this.$store.state.userInfo.smsSignRemind === 'yes'
  },
  methods: {
    async SMSchhange(SMSstate) {
      this.SMSstate = !SMSstate;
      this.processLoading = true;
      await changeSmsRemindSwitch().then(res => {
        this.processLoading = false;
        if (res.code == 200) {
          this.SMSstate = SMSstate;
          this.$message({
            message: '设置成功',
            type: 'success'
          });
        } else {
          this.SMSstate = !SMSstate;
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        }
      }).catch(err => {
        this.processLoading = false;
      })


    },
    getUserAccountInfo() {
      getUserAccountInfo().then(res => {
        if (res.code == 200) {
          this.$store.commit("SET_USER_INFO", res.data);
          this.SMSstate = this.$store.state.userInfo.smsSignRemind === 'yes';
        }
      }).catch(err => {
      })
    }
  },
};
</script>
<style>
#user-info-layer .base-input input {
  height: 36px;
}
</style>
<style scoped>
.base-info {
  margin-top: 20px;
  margin-left: 20px;
}

.base-item {
  position: relative;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  margin-top: 15px;
}

.base-title {
  float: left;
  width: 100px;
}

.base-content {
  float: left;
  margin-left: 50px;
  color: #333333;
}

.base-input {
  position: absolute;
  left: 150px;
  top: 0;
  width: 150px;
  height: 36px;
}

.base-edit {
  /* width: 67px;
  height: 26px; */
  /* position: absolute;
  left: 350px;
  top: 0px; */
  /* background: #3296FA;
  border-radius: 10px;
  display: block;
  color: white;
  font-size: 13px;
  text-align: center;
  line-height: 26px;
  padding: 0; */
  padding: 0;
  margin-left: 50px;
}

.add-item {
  position: absolute;
  left: 520px;
  top: 0;
  color: #1b96ff;
}

.person-info {
  margin: 36px 0 0 46px;
}

.company-info {
  /* width: 942px; */
  margin-top: 20px;
}

.company-list {
  width: 100%;
  height: 54px;
  overflow-x: auto;
  overflow-y: hidden;
}

.company-list a {
  display: block;
  width: 175px;
  height: 43px;
  text-align: center;
  overflow: hidden;
  font-size: 16px;
  color: #333333;
  background: #e5e5e5;
  line-height: 43px;
  float: left;
  margin-right: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-list a:last-child {
  margin-right: 0;
}

.company-list a.active {
  background: #ffffff;
}

.company-content {
  /* width: 942px; */
  min-height: calc(100vh - 587px);
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
}

.company-name {
  font-size: 16px;
  color: #333333;
  width: 855px;
  margin: 27px auto 0;
  padding-bottom: 17px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 18px;
}

.company-box {
  margin: 15px 0 0 43px;
}

.company-box .base-title {
  width: 112px;
}

.company-box .base-content {
  margin-left: 43px;
  margin-right: 20px;
}

.company-box .add-item {
  left: 433px;
}
</style>
<style lang="scss" scoped>
.content-block {
  position: relative;
  height: 100%;
}

.info-title {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  border-bottom: 1px solid #F2F3F5;
  padding-left: 22px;
}

.content-layer {
  padding: 20px;
}

.set-card {
  width: 446px;
  height: 82px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #E5E8EF;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .set-card-left {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .set-title-wrap {
      display: flex;
      align-items: center;
    }

    .set-title {
      display: block;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #1D2129;
      margin-right: 12px;
    }

    .set-sub {
      font-size: 12px;
      font-weight: 400;
      color: #86909C;
    }

    .set-tag {
      width: 68px;
      height: 20px;
      background: #E6F6E7;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 8px;
      font-size: 12px;
      font-weight: 500;
      color: #38A65A;

      &.enable {
        color: #38A65A;
        background: #E6F6E7;
      }

      &.disable {
        color: #EB6069;
        background: #F3EAEB;
      }
    }
  }

}
</style>